import { FOOTER_MJML } from "../common/footer";
import { PRODUCT_HEADER } from "../common/header";

export const productUpsell = `
<mjml>
  <mj-head>
    <mj-title>Upgrade Your Experience with {{premium_product_name}}</mj-title>
    <mj-preview>Unlock premium features and take your experience to the next level</mj-preview>
    <mj-attributes>
      <mj-all font-family="Arial, sans-serif" />
      <mj-text font-size="16px" color="#333333" line-height="1.5" />
    </mj-attributes>
    <mj-style>
      .comparison-table td, .comparison-table th {
        border-bottom: 1px solid #e0e0e0;
        padding: 12px 15px;
        text-align: left;
      }
      .comparison-table th {
        background-color: #f5f5f5;
        font-weight: bold;
      }
      .check-icon {
        color: #52c41a;
        font-weight: bold;
      }
      .premium-highlight {
        background-color: #f0f7ff;
      }
      .current-plan {
        background-color: #f5f5f5;
        border-radius: 8px;
      }
      .premium-plan {
        background-color: #f0f7ff;
        border-radius: 8px;
        border: 1px solid #1890ff;
      }
      .testimonial-box {
        border-left: 4px solid #1890ff;
        padding-left: 15px;
      }
      .exclusive-banner {
        background-color: #1890ff;
        color: white;
        padding: 5px 15px;
        border-radius: 4px;
        font-weight: bold;
        display: inline-block;
        font-size: 14px;
      }
      .limited-offer {
        color: #ff4d4f;
        font-weight: bold;
      }
    </mj-style>
  </mj-head>
  <mj-body background-color="#f5f5f5">
    ${PRODUCT_HEADER(
      "Exclusive Upgrade Opportunity",
      "Take your experience to the next level"
    )}
    
    <!-- Introduction section -->
    <mj-section background-color="#ffffff" padding="30px" border-radius="8px">
      <mj-column>
        <mj-text font-size="22px" color="#333333" font-family="Arial, sans-serif">Hello {{first_name}},</mj-text>
        <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">
          Thank you for being a valued user of {{current_product_name}}. We've noticed how actively you've been using our platform, and we thought you might be interested in unlocking even more capabilities with our premium offering.
        </mj-text>
        <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">
          <span class="exclusive-banner">EXCLUSIVE OFFER</span>
        </mj-text>
        <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">
          Upgrade to {{premium_product_name}} today and get <span class="limited-offer">{{discount_amount}} off for the first {{discount_period}}</span> – plus all the premium features listed below!
        </mj-text>
      </mj-column>
    </mj-section>
    
    <!-- Plans comparison section -->
    <mj-section background-color="#ffffff" padding="0 30px 30px" border-radius="8px">
      <mj-column width="100%">
        <mj-text font-size="20px" color="#333333" font-weight="bold">Your Current Plan vs. Premium</mj-text>
        <mj-divider border-color="#1890ff" border-width="2px" width="80px" padding-bottom="20px" />
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="0 30px 30px" border-radius="8px">
      <mj-column width="48%" css-class="current-plan" padding="20px">
        <mj-text font-size="20px" font-weight="bold" align="center">
          Your Current Plan
        </mj-text>
        <mj-text font-size="24px" font-weight="bold" align="center" color="#1890ff" padding-top="0">
          {{current_plan_name}}
        </mj-text>
        <mj-divider border-color="#e0e0e0" border-width="1px" padding="10px 0" />
        
        <mj-text font-size="16px" padding-bottom="5px">
          <span class="check-icon">✓</span> {{current_feature_1}}
        </mj-text>
        <mj-text font-size="16px" padding-bottom="5px">
          <span class="check-icon">✓</span> {{current_feature_2}}
        </mj-text>
        <mj-text font-size="16px" padding-bottom="5px">
          <span class="check-icon">✓</span> {{current_feature_3}}
        </mj-text>
        <mj-text font-size="16px" padding-bottom="5px">
          <span class="check-icon">✓</span> {{current_feature_4}}
        </mj-text>
        <mj-text font-size="16px" color="#999999" padding-bottom="5px">
          ✕ {{premium_feature_1}}
        </mj-text>
        <mj-text font-size="16px" color="#999999" padding-bottom="5px">
          ✕ {{premium_feature_2}}
        </mj-text>
        <mj-text font-size="16px" color="#999999" padding-bottom="5px">
          ✕ {{premium_feature_3}}
        </mj-text>
        
        <mj-spacer height="20px" />
        <mj-text font-size="18px" font-weight="bold" align="center" padding-bottom="5px">
          {{current_price}}
        </mj-text>
        <mj-text font-size="14px" color="#777777" align="center" padding-top="0">
          per month
        </mj-text>
      </mj-column>
      
      <mj-column width="48%" css-class="premium-plan" padding="20px">
        <mj-text font-size="20px" font-weight="bold" align="center">
          Premium Plan
        </mj-text>
        <mj-text font-size="24px" font-weight="bold" align="center" color="#1890ff" padding-top="0">
          {{premium_plan_name}}
        </mj-text>
        <mj-divider border-color="#1890ff" border-width="1px" padding="10px 0" />
        
        <mj-text font-size="16px" padding-bottom="5px">
          <span class="check-icon">✓</span> {{current_feature_1}}
        </mj-text>
        <mj-text font-size="16px" padding-bottom="5px">
          <span class="check-icon">✓</span> {{current_feature_2}}
        </mj-text>
        <mj-text font-size="16px" padding-bottom="5px">
          <span class="check-icon">✓</span> {{current_feature_3}}
        </mj-text>
        <mj-text font-size="16px" padding-bottom="5px">
          <span class="check-icon">✓</span> {{current_feature_4}}
        </mj-text>
        <mj-text font-size="16px" padding-bottom="5px" font-weight="bold">
          <span class="check-icon">✓</span> {{premium_feature_1}}
        </mj-text>
        <mj-text font-size="16px" padding-bottom="5px" font-weight="bold">
          <span class="check-icon">✓</span> {{premium_feature_2}}
        </mj-text>
        <mj-text font-size="16px" padding-bottom="5px" font-weight="bold">
          <span class="check-icon">✓</span> {{premium_feature_3}}
        </mj-text>
        
        <mj-spacer height="20px" />
        <mj-text font-size="18px" font-weight="bold" align="center" padding-bottom="0">
          <span style="text-decoration: line-through; color: #999; font-size: 16px; margin-right: 8px;">{{premium_regular_price}}</span>
          {{premium_discounted_price}}
        </mj-text>
        <mj-text font-size="14px" color="#777777" align="center" padding-top="0">
          per month for the first {{discount_period}}
        </mj-text>
        <mj-button background-color="#1890ff" color="#ffffff" href="{{upgrade_url}}" border-radius="4px" font-weight="bold" font-size="16px" align="center" padding-top="15px">
          Upgrade Now
        </mj-button>
      </mj-column>
    </mj-section>
    
    <!-- Feature spotlight section -->
    <mj-section background-color="#ffffff" padding="30px" border-radius="8px">
      <mj-column>
        <mj-text font-size="20px" color="#333333" font-weight="bold">Premium Feature Spotlight</mj-text>
        <mj-divider border-color="#1890ff" border-width="2px" width="80px" padding-bottom="20px" />
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="0 30px 30px" border-radius="8px">
      <mj-column width="30%">
        <mj-image src="https://via.placeholder.com/200?text=Feature" alt="Featured Functionality" width="200px" />
      </mj-column>
      <mj-column width="70%">
        <mj-text font-size="18px" font-weight="bold" color="#333333">
          {{spotlight_feature}}
        </mj-text>
        <mj-text font-size="16px" color="#555555">
          {{spotlight_description}}
        </mj-text>
        <mj-text font-size="16px" color="#555555">
          {{spotlight_benefit}}
        </mj-text>
      </mj-column>
    </mj-section>
    
    <!-- Testimonial section -->
    <mj-section background-color="#f0f7ff" padding="30px" border-radius="8px">
      <mj-column>
        <mj-text font-size="18px" color="#333333" font-weight="bold" align="center">
          What Premium Users Are Saying
        </mj-text>
        <mj-divider border-color="#1890ff" border-width="2px" width="80px" padding-bottom="20px" />
        <mj-text font-size="16px" color="#555555" css-class="testimonial-box">
          "{{testimonial_quote}}"
        </mj-text>
        <mj-text font-size="14px" font-weight="bold" align="right" padding-top="10px">
          — {{testimonial_name}}, {{testimonial_company}}
        </mj-text>
      </mj-column>
    </mj-section>
    
    <!-- Call to action section -->
    <mj-section background-color="#ffffff" padding="30px" border-radius="8px">
      <mj-column>
        <mj-text font-size="18px" font-weight="bold" align="center">
          Ready to upgrade your experience?
        </mj-text>
        <mj-text font-size="16px" color="#555555" align="center">
          This special offer is available until <span class="limited-offer">{{offer_expiry_date}}</span>. Upgrade now to lock in this exclusive rate!
        </mj-text>
        <mj-button background-color="#1890ff" color="#ffffff" font-family="Arial, sans-serif" href="{{upgrade_url}}" width="250px" border-radius="4px" font-weight="bold" font-size="16px" align="center">
          Upgrade to Premium
        </mj-button>
        <mj-text font-size="14px" color="#777777" align="center" padding-top="10px">
          Need help deciding? <a href="https://www.copilotly.com/contact" style="color: #1890ff; text-decoration: none;">Contact our team</a>
        </mj-text>
      </mj-column>
    </mj-section>
    
    <!-- Money-back guarantee -->
    <mj-section background-color="#ffffff" padding="0 30px 30px" border-radius="8px">
      <mj-column>
        <mj-text font-size="14px" color="#555555" align="center">
          {{guarantee_text}}
        </mj-text>
      </mj-column>
    </mj-section>
    
    ${FOOTER_MJML}
  </mj-body>
</mjml>
`;

// Template metadata for the gallery
export default {
  id: "productUpsell",
  name: "Product Upsell",
  category: "product",
  description:
    "An effective email template designed to encourage users to upgrade to a premium plan, featuring clear plan comparisons, highlighted exclusive benefits, and limited-time offers.",
  features: [
    "Side-by-side plan comparison",
    "Premium feature highlights",
    "Customer testimonials",
    "Exclusive promotional offers",
    "Urgency creators with deadlines",
  ],
  subject: "Upgrade Your Experience with Premium",
  subTitle:
    "Unlock premium features and take your experience to the next level",
  mjmlTemplate: productUpsell,
};
